<template>
    <div
        class="tab"
        :id="options.id"
        v-show="show"
        :class="[{'only-one':panels.length===1,fill:options.fill},state]"
        :style="{height}"
    >
        <div class="tab-switch-icon" v-on:click="toggle"></div>
        <ul class="tab-header">
            <li
                v-for="(item,index) in panels"
                :class="{'active' : showIndex === index}"
                @click="switchPanel(index)"
                :key="index"
                v-show="item.show!==false"
                :id="item.id"
            >{{propI18N(item.title)}}</li>
        </ul>
        <transition name="tab-transition">
            <div class="tab-content" v-show="state !== 'collapsed'">
                <div
                    v-for="(item,index) in panels"
                    class="tab-pane"
                    :class="{'active' : showIndex === index}"
                    :key="index"
                    v-show="item.show!==false"
                    :id="item.id"
                >
                    <scroll :ops="{scrollPanel:{scrollingX:false}}">
                        <div class="panel-body" ref="panelBody" :class="heightAuto">
                            <slot :name="item.id"></slot>
                        </div>
                    </scroll>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import Gikam from "../../core/gikam-core";
import Vue from "vue";

export default {
    props: {
        options: Object
    },

    data() {
        return {
            panels: this.options.panels,
            showIndex: -1,
            state: void 0,
            show: this.options.show
        };
    },

    computed: {
        height() {
            if (this.options.fill) {
                return "100%";
            }
            const height = this.options.height;
            if (!height) {
                return;
            }
            return Gikam.isNumber(height) ? height + "px" : height;
        },
        heightAuto() {
            return this.options.height == "auto" && this.options.fill === false
                ? "height-auto"
                : "";
        }
    },

    mounted() {
        this.showIndex = this.options.showIndex;
        this.notify();
    },

    watch: {
        showIndex(index) {
            this.tab.trigger("actived", {
                index: index,
                title: Gikam.propI18N(this.panels[index].title)
            });
        }
    },

    inject: ["tab"],

    methods: {
        switchPanel(index) {
            this.showIndex = index;
        },

        //开关tab
        toggle() {
            if (!this.state || this.state === "expand") {
                this.state = "collapsed";
            } else {
                this.state = "expand";
            }
        },

        propI18N(text) {
            return Gikam.propI18N(text);
        },

        notify() {
            this.$nextTick(() => {
                if (!this.options.id) {
                    return;
                }
                const pro = Gikam.createdComponent[this.options.id];
                if (pro) {
                    pro.resolve(this);
                    delete Gikam.createdComponent[this.options.id];
                }
            });
        },

        //获取指定id的panel的数据和索引
        getPanelDataById(id) {
            let index;
            let data;
            Gikam.each(this.panels, function(i) {
                if (this.id === id) {
                    index = i;
                    data = this;
                    return false;
                }
            });
            return { index, data };
        },

        //显示相应panel
        showPanel(id) {
            const panel = this.getPanelDataById(id);
            if (Gikam.isNotEmpty(panel.index)) {
                this.showIndex = panel.index;
            } else {
                Gikam.error(`can not find ${id} when use showPanel`);
            }
        },

        //移除tab下的面板
        removePanel(id) {
            const panel = this.getPanelDataById(id);
            if (Gikam.isNotEmpty(panel.data)) {
                Vue.set(panel.data, "show", false);
            } else {
                Gikam.error(`can not find ${id} when use removePanel`);
            }
            //如果隐藏当前展示的panel，则隐藏之后需要前面或后面的panle进行展示
            if (panel.index === this.showIndex) {
                this.showIndex = panel.index === 0 ? 1 : panel.index - 1;
            }
        },

        //显示tab下的面板
        revertPanel(id) {
            let array = this.panels.filter(item => {
                return item.id === id;
            });
            if (Gikam.isNotEmpty(array)) {
                Vue.set(array[0], "show", true);
            } else {
                Gikam.error(`can not find ${id} when use revertPanel`);
            }
        }
    }
};
</script>

<style scoped>
.tab-transition-enter-active,
.tab-transition-leave-active {
    transition: opacity 0.3s linear, transform 0.3s linear;
}

.tab-transition-enter-to,
.tab-transition-leave {
    opacity: 1;
    transform: translate3d(0, 0, 0);
}

.tab-transition-enter,
.tab-transition-leave-to {
    opacity: 0;
    transform: translate3d(0, -20px, 0);
}

.tab {
    background-color: #fff;
    position: relative;
    padding: 8px 8px 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.tab .tab-switch-icon {
    transition: transform 0.3s;
    background: url(../../../img/down-drop.png) no-repeat center;
}

.tab.collapsed .tab-switch-icon {
    transform: rotate(180deg);
}

.tab > ul.tab-header {
    /* 解决360浏览器下部分详情页显示异常的情况 */
    min-height: 29px;
    list-style-type: none;
    display: flex;
    padding: 0;
    margin: 0;
    background-color: #fafafa;
    border: 1px solid #eee;
    border-bottom: none;
    z-index: 1;
}

.tab.collapsed > ul.tab-header {
    border-bottom: 1px solid #eee;
}

.tab > .tab-switch-icon {
    position: absolute;
    right: 16px;
    width: 38px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #666;
    cursor: pointer;
    z-index: 2;
}

.tab > .tab-content {
    border: 1px solid #eee;
    border-top: none;
    flex: 1;
}

.tab > .tab-content > .tab-pane {
    display: none;
    height: 100%;
}

.tab > .tab-content > .tab-pane.active {
    display: block;
}

.tab > .tab-content > .tab-pane >>> .form > .panel {
    border-left: none;
    border-right: none;
}

.tab > ul > li {
    height: 29px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
    border-right: 1px solid #eee;
    border-bottom: 1px solid #eee;
    cursor: pointer;
    font-weight: bold;
}

.tab > ul > li.active {
    background-color: #fff;
    position: relative;
    color: #007aff;
    font-weight: normal;
}

.tab:not(.only-one) > ul > li.active {
    box-shadow: 0 -2px 0 #007aff inset;
}

.tab.only-one > ul > li.active {
    color: rgba(0, 0, 0, 0.65);
    font-weight: bold;
}

.tab.only-one > ul > li.active:before {
    content: "";
    display: block;
    position: absolute;
    background-color: #fff;
    height: 1px;
    bottom: -1px;
    left: 0;
    right: 0;
}

.panel-body {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    overflow-x: auto;
}

.panel-body.height-auto {
    position: unset;
}
</style>



